
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Tabs',
  props: ['modelValue'],
  components: {},
  setup(props, { emit }) {
    return {}
  }
})
